import React from 'react';
import PropTypes from 'prop-types';

import WMSCarrierIcon from "components/WMS/WMSCarrierIcon";

CarrierIcon.propTypes = {
    shippingMethod: PropTypes.object
};

function CarrierIcon({shippingMethod}) {
    return (
        <WMSCarrierIcon
            iconName={shippingMethod.carrierIcon}
            altName={shippingMethod.carrierIcon}
            width={16}
            height={16}
        />
    );
}

export default CarrierIcon;
